import { Card, Link } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import DocumentIcon from '@app/components/icons/DocumentIcon';
import { customDocumentsList } from '@app/configs/documentsLists';
import CustomDocuments from '@modules/borrower/components/loanDetails/CustomDocuments';
const Documents = ({ documents, isBorrower }) => {
    const { t } = useTranslation();
    return (<Card>
            <div className="flex items-start pb-6">
                <h2 className="text-2xl font-semibold text-gray-900">{t('financing.loan_details.documents.title')}</h2>
            </div>
            <div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 md:gap-y-5">
                    {documents.map((doc) => (<Link key={doc.name} href={doc.url} target="_blank" rel="noreferrer" size="md" iconLeft={<DocumentIcon className="size-4 shrink-0"/>} label={t(doc.name)}/>))}
                    <CustomDocuments documents={isBorrower ? customDocumentsList.borrower : customDocumentsList.investor}/>
                </div>
            </div>
        </Card>);
};
export default Documents;
